var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentOpenpay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 9.18,
    viewBox: "0 0 48 9.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#333332}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Logo-Payment-Openpay",
    transform: "translate(-.004 -9.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Openpay_Single-Line-Logo-without-Strapline_RGB_Granite-Grey",
    transform: "translate(.004 9.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path",
    d: "M36.648.218v3.207a3.061 3.061 0 0 1-2.232 2.943v.551h-1.647v-.551a3.061 3.061 0 0 1-2.233-2.943V.218h1.631v3.207a1.419 1.419 0 0 0 2.836 0V.218z",
    className: "prefix__cls-1",
    transform: "translate(11.352 .068)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle",
    d: "M0 0H1.646V1.646H0z",
    className: "prefix__cls-1",
    transform: "translate(44.111 7.533)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape",
    d: "M28.593 4.915a1.655 1.655 0 0 1-1.643-1.627 1.628 1.628 0 0 1 1.643-1.643 1.648 1.648 0 0 1 1.642 1.584v.06a1.6 1.6 0 0 1-.03.315 1.638 1.638 0 0 1-1.613 1.314m3.258-1.686a3.265 3.265 0 1 0-1.65 2.886v.271h1.647V3.232",
    className: "prefix__cls-1",
    transform: "translate(9.412 -.007)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle-2",
    d: "M0 0H1.646V1.646H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle",
    transform: "translate(6.962 7.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-2",
    d: "M8.337 4.911A1.635 1.635 0 1 1 9.98 3.284a1.655 1.655 0 0 1-1.643 1.627m0-4.9a3.27 3.27 0 0 0-3.259 3.265v3.718h1.646v-.882a3.265 3.265 0 1 0 1.613-6.1",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(1.884 -.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle-3",
    d: "M0 0H1.646V1.646H0z",
    className: "prefix__cls-1",
    "data-name": "Rectangle",
    transform: "translate(27.724 7.534)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-3",
    d: "M23.472 4.911a1.635 1.635 0 1 1 1.643-1.626 1.655 1.655 0 0 1-1.643 1.626m0-4.9a3.27 3.27 0 0 0-3.262 3.267V7h1.646v-.887a3.265 3.265 0 1 0 1.613-6.1",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(7.511 -.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-4",
    d: "M4.9 3.282a1.635 1.635 0 1 1-1.632-1.634A1.635 1.635 0 0 1 4.9 3.282m1.638 0a3.27 3.27 0 1 0-3.27 3.27 3.27 3.27 0 0 0 3.27-3.27",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(-.004 -.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path-2",
    d: "M18.361.012A3.062 3.062 0 0 0 15.3 3.07v3.314h1.644V3.07a1.42 1.42 0 0 1 2.84 0v3.314h1.633V3.07A3.061 3.061 0 0 0 18.361.012",
    className: "prefix__cls-1",
    "data-name": "Path",
    transform: "translate(5.686 -.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Shape-5",
    d: "M11.937 2.512l.023-.04a1.673 1.673 0 0 1 2.935 0l.022.04zm4.663-.02a3.27 3.27 0 1 0-3.175 4.058 3.23 3.23 0 0 0 1.975-.671l-1.143-1.146a1.671 1.671 0 0 1-2.232-.533L12 4.155h4.579a3.765 3.765 0 0 0 .021-1.661",
    className: "prefix__cls-1",
    "data-name": "Shape",
    transform: "translate(3.772 -.01)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentOpenpay);
export default __webpack_public_path__ + "static/media/logo-payment-openpay.08f4352f.svg";
export { ForwardRef as ReactComponent };